export const DOMOPHONE_PERMISSIONS = {
	STREAM_TASK_ASSIGNMENT_NOTIFICATIONS: 'domophone:streamTaskAssignmentNotifications', // notifications/stream

	INTERCOM_PANELS_DIAGNOSTIC: 'domophone:intercomPanelsDiagnostic', // intercom/{appId}/panel/diagnostic
	GET_INTERCOM_PANEL_APARTMENTS: 'domophone:getIntercomPanelApartments', // intercom/{appId}/panel
	CREATE_INTERCOM_PANEL_APARTMENT: 'domophone:createIntercomPanelApartment', // intercom/{appId}/panel
	GET_INTERCOM_PANEL_APARTMENT: 'domophone:getIntercomPanelApartment', // intercom/{appId}/panel/{flat}
	UPDATE_INTERCOM_PANEL_APARTMENT: 'domophone:updateIntercomPanelApartment', // intercom/{appId}/panel/{flat}
	// Права интерфейса: показ и редактирование отдельных полей квартиры.
	EDIT_INTERCOM_PANEL_APARTMENT_NUMBER: 'domophone:editIntercomPanelApartmentNumber',
	EDIT_INTERCOM_PANEL_APARTMENT_SIP_CALLS: 'domophone:editIntercomPanelApartmentSipCalls',
	EDIT_INTERCOM_PANEL_APARTMENT_DEBTOR: 'domophone:editIntercomPanelApartmentDebtor',
	EDIT_INTERCOM_PANEL_APARTMENT_OPEN_SOUND: 'domophone:editIntercomPanelApartmentOpenSound',
	DELETE_INTERCOM_PANEL_APARTMENT: 'domophone:deleteIntercomPanelApartment', // intercom/{appId}/panel/{flat}
	GET_INTERCOM_PANEL_SWITCH_MODELS: 'domophone:getIntercomPanelSwitchModels', // intercom/{appId}/panel/switch/models
	GET_INTERCOM_PANEL_SWITCH_INSTALLED_MODELS: 'domophone:getIntercomPanelSwitchInstalledModels', // intercom/{appId}/panel/switch/installed/models
	GET_INTERCOM_PANEL_SWITCH_MATRIX: 'domophone:getIntercomPanelSwitchMatrix', // intercom/{appId}/panel/switch/matrix/{matrixNumber}
	UPDATE_INTERCOM_PANEL_SWITCH_MATRIX: 'domophone:updateIntercomPanelSwitchMatrix', // intercom/{appId}/panel/switch/matrix/{matrixNumber}
	GET_INTERCOM_DISPLAY_SETTINGS: 'domophone:getIntercomDisplaySettings', // intercom/{appId}/panel/display
	UPDATE_INTERCOM_DISPLAY_SETTINGS: 'domophone:updateIntercomDisplaySettings', // intercom/{appId}/panel/display
	GET_INTERCOM_AUDIO_LEVELS: 'domophone:getIntercomAudioLevels', // intercom/{appId}/audio/levels
	UPDATE_INTERCOM_AUDIO_LEVELS: 'domophone:updateIntercomAudioLevels', // intercom/{appId}/audio/levels
	GET_INTERCOM_MCU_EQUALIZER: 'domophone:getIntercomMcuEqualizer', // intercom/{appId}/mcu/equalizer
	UPDATE_INTERCOM_MCU_EQUALIZER: 'domophone:updateIntercomMcuEqualizer', // intercom/{appId}/mcu/equalizer
	GET_INTERCOM_CAMERA_CODEC: 'domophone:getIntercomCameraCodec', // intercom/{appId}/camera/codec
	UPDATE_INTERCOM_CAMERA_CODEC: 'domophone:updateIntercomCameraCodec', // intercom/{appId}/camera/codec
	GET_INTERCOM_PANEL_FLAT_SETTINGS: 'domophone:getIntercomPanelFlatSettings', // intercom/{appId}/panel/flats/{flat}/settings
	GET_INTERCOM_KEY_SETTINGS: 'domophone:getIntercomKeySettings', // intercom/{appId}/key/settings
	UPDATE_INTERCOM_KEY_SETTINGS: 'domophone:updateIntercomKeySettings', // intercom/{appId}/key/settings
	GET_INTERCOM_KEY_STORE: 'domophone:getIntercomKeyStore', // intercom/{appId}/key/store
	ADD_INTERCOM_KEY_STORE: 'domophone:addIntercomKeyStore', // intercom/{appId}/key/store
	MERGE_INTERCOM_KEY_STORE: 'domophone:mergeIntercomKeyStore', // intercom/{appId}/key/store/merge
	GET_INTERCOM_KEY_STORE_BY_ID: 'domophone:getIntercomKeyStoreById', // intercom/{appId}/key/store/{keyId}
	UPDATE_INTERCOM_KEY_STORE_BY_ID: 'domophone:updateIntercomKeyStoreById', // intercom/{appId}/key/store/{keyId}
	DELETE_INTERCOM_KEY_STORE_BY_ID: 'domophone:deleteIntercomKeyStoreById', // intercom/{appId}/key/store/{keyId}
	GET_INTERCOM_RELAY_SETTINGS: 'domophone:getIntercomRelaySettings', // intercom/{appId}/relay/settings
	UPDATE_INTERCOM_RELAY_SETTINGS: 'domophone:updateIntercomRelaySettings', // intercom/{appId}/relay/settings
	ADD_PANEL_COMMON_CODE: 'domophone:addPanelCommonCode', // intercom/{appId}/commoncode/settings
	DELETE_PANEL_COMMON_CODE: 'domophone:deletePanelCommonCode', // intercom/{appId}/commoncode/settings
	GET_INTERCOM_LOGS: 'domophone:getIntercomLogs', // intercom/{appId}/logs/{service}
	INTERCOM_NETWORK_PING: 'domophone:intercomNetworkPing', // intercom/{appId}/network/ping
	GET_INTERCOM_NETWORK: 'domophone:getIntercomNetwork', // intercom/{appId}/network
	UPDATE_INTERCOM_NETWORK: 'domophone:updateIntercomNetwork', // intercom/{appId}/network
	GET_INTERCOM_SYSLOG: 'domophone:getIntercomSyslog', // intercom/{appId}/network/syslog
	UPDATE_INTERCOM_SYSLOG: 'domophone:updateIntercomSyslog', // intercom/{appId}/network/syslog
	GET_INTERCOM_SIP_SETTINGS: 'domophone:getIntercomSipSettings', // intercom/{appId}/sip/settings
	UPDATE_INTERCOM_SIP_SETTINGS: 'domophone:updateIntercomSipSettings', // intercom/{appId}/sip/settings
	GET_INTERCOM_SYSTEM_INFO: 'domophone:getIntercomSystemInfo', // intercom/{appId}/system/info
	GET_INTERCOM_SYSTEM_VERSIONS: 'domophone:getIntercomSystemVersions', // intercom/{appId}/system/versions
	GET_INTERCOM_SYSTEM_UPGRADE: 'domophone:getIntercomSystemUpgrade', // intercom/{appId}/system/upgrade
	UPDATE_INTERCOM_SYSTEM_UPGRADE: 'domophone:updateIntercomSystemUpgrade', // intercom/{appId}/system/upgrade
	REBOOT_INTERCOM: 'domophone:rebootIntercom', // intercom/{appId}/system/reboot
	GET_INTERCOM_SYSTEM_SETTINGS: 'domophone:getIntercomSystemSettings', // intercom/{appId}/system/settings
	UPDATE_INTERCOM_SYSTEM_SETTINGS: 'domophone:updateIntercomSystemSettings', // intercom/{appId}/system/settings
	FACTORY_RESET: 'domophone:factoryReset', // intercom/{appId}/system/factory-reset
	GET_INTERCOM_MCU_TAMPER: 'domophone:getIntercomMcuTamper', // intercom/{appId}/mcu/tamper
	UPDATE_INTERCOM_MCU_TAMPER: 'domophone:updateIntercomMcuTamper', // intercom/{appId}/mcu/tamper
	GET_INTERCOM_OPEN_CODES: 'domophone:getIntercomOpenCodes', // intercom/{appId}/openCode
	ADD_INTERCOM_OPEN_CODES: 'domophone:addIntercomOpenCodes', // intercom/{appId}/openCode
	DELETE_INTERCOM_OPEN_CODE: 'domophone:deleteIntercomOpenCode', // intercom/{appId}/openCode/{flat}/{code}
	GET_INTERCOM_PANEL_SIP_NUMBERS: 'domophone:getIntercomPanelSipNumbers', // intercom/{appId}/panel/{flat}/sip-numbers
	UPDATE_INTERCOM_PANEL_SIP_NUMBERS: 'domophone:updateIntercomPanelSipNumbers', // intercom/{appId}/panel/{flat}/sip-numbers
	CREATE_SIP_TEST: 'domophone:createSipTest', // intercom/{appId}/panel/{flat}/siptest
	CREATE_ANALOG_TEST: 'domophone:createAnalogTest', // intercom/{appId}/panel/{flat}/analogtest
	FINISH_TEST_CALL: 'domophone:finishTestCall', // intercom/{appId}/panel/call/stop
	GET_HOUSE_FLATS_HANDSET_SETTINGS: 'domophone:getHouseFlatsHandsetSettings', // intercom/houses/handsetSettings
	UPDATE_HOUSE_FLATS_HANDSET_SETTINGS: 'domophone:updateHouseFlatsHandsetSettings', // intercom/houses/handsetSettings

	CREATE_ACCESS_DISTRIBUTION_RUN: 'domophone:createAccessDistributionRun', // access-distribution-runs
	GET_ACCESS_DISTRIBUTION_RUN_BY_ID: 'domophone:getAccessDistributionRunById', // access-distribution-runs/{id}
	GET_ACCESS_DISTRIBUTION_RUN_NODES: 'domophone:getAccessDistributionRunNodes', // access-distribution-runs/{id}/nodes
	GET_ACCESS_DISTRIBUTION_RUNS: 'domophone:getAccessDistributionRuns', // access-distribution-runs

	GET_PLANNER_TASKS: 'domophone:getPlannerTasks', // planner/tasks
	GET_PLANNER_TASK_BY_ID: 'domophone:getPlannerTaskById', // planner/tasks/{idTask}
	GET_PLANNER_TASK_REPORT: 'domophone:getPlannerTaskReport', // planner/tasks/{id_task}/report
	PUT_PLANNER_TASK_REPORT: 'domophone:putPlannerTaskReport', // planner/tasks/{id_task}/report
	GET_PLANNER_TASKS_SLA: 'domophone:getPlannerTasksSLA', // planner/tasks/sla
	GET_PLANNER_TASKS_COUNT_BY_DAY: 'domophone:getPlannerTasksCountByDay', // planner/tasks/count-by-day
	GET_GATES_BY_ADDRESS: 'domophone:getGatesByAddress', // planner/digitalcity/gatesByAddress
	REGISTER_KEY: 'domophone:registerKey', // planner/digitalcity/registerKey

	GET_GATES: 'domophone:getGates', // gates
	CREATE_GATE: 'domophone:createGate', // gates
	GET_GATE_BY_ID: 'domophone:getGateById', // gates/{id}
	UPDATE_GATE_BY_ID: 'domophone:updateGateById', // gates/{id}
	DELETE_GATE_BY_ID: 'domophone:deleteGateById', // gates/{id}

	GET_ELTC_ADDRESS_TOWNS: 'domophone:getEltcAddressTowns', // eltc/address/towns
	GET_ELTC_ADDRESS_TOWN_STREETS: 'domophone:getEltcAddressTownStreets', // eltc/address/towns/{idTown}/streets
	GET_ELTC_ADDRESS_TOWN_STREET_HOUSES: 'domophone:getEltcAddressTownStreetHouses', // eltc/address/towns/{idTown}/streets/{idStreet}/houses
	GET_ELTC_ADDRESS_HOUSE_FLATS: 'domophone:getEltcAddressHouseFlats', // eltc/address/houses/{idHouse}/flats

	FIND_FIAS_ADDRESS_BY_EXTERNAL_ID: 'domophone:findFiasAddressByExternalId', // address/resolve
	LINK_FIAS_ADDRESS_TO_EXTERNAL_RECORD: 'domophone:linkFiasAddressToExternalRecord', // address/resolve
	LIST_ENTRANCES_BY_HOUSE_FIAS_GUID: 'domophone:listEntrancesByHouseFiasGuid', // address/{houseGuid}/entrances
	REGISTER_ENTRANCES_FOR_HOUSE: 'domophone:registerEntrancesForHouse', // address/{houseGuid}/entrances
	ENTRANCE_BY_ENTRANCE_GUID: 'domophone:entranceByEntranceGuid', // address/entrances/{entranceGuid}
	DELETE_ENTRANCE_BY_ENTRANCE_GUID: 'domophone:deleteEntranceByEntranceGuid', // address/entrances/{entranceGuid}
	UPDATE_ENTRANCE_BY_ENTRANCE_GUID: 'domophone:updateEntranceByEntranceGuid', // address/entrances/{entranceGuid}

	GET_ANALYTICS_ADDED_FLATS: 'domophone:getAnalyticsAddedFlats', // digitalcity/analytics/addedFlats
	GET_AUDIT_EVENTS: 'domophone:getAuditEvents', // audit/events

	GET_INTERCOM_STATUS: 'domophone:getIntercomStatus', // api/v1/partner/intercom
	DISABLE_INTERCOM_CALL: 'domophone:disableIntercomCall', // api/v1/intercom/disable-call
	ENABLE_INTERCOM_CALL: 'domophone:enableIntercomCall', // api/v1/intercom/enable-call

	GET_SIP_ACCOUNT_FOR_FLAT: 'domophone:getSipAccountForFlat', // sip-accounts/for-flat
	CREATE_SIP_ACCOUNT_FOR_FLAT: 'domophone:createSipAccountForFlat', // sip-accounts/for-flat

	GET_SUPPORTED_DEVICE_TYPES: 'domophone:getSupportedDeviceTypes', // device-setup/device-types
	GET_ELTC_HOUSE_INFO_FOR_WIZARD: 'domophone:getEltcHouseInfoForWizard', // device-setup/eltc-houses/{idHouse}/info
	SAVE_CONFIGURATION: 'domophone:saveConfiguration', // device-setup/save-configuration
	GET_PLANNED_DEVICES: 'domophone:getPlannedDevices', // device-setup/devices/available
	CONFIGURE_DEVICE_SLOT: 'domophone:configureDeviceSlot', // device-setup/devices/configure
	RUN_PRESETTING: 'domophone:runPresetting', // device-setup/devices/run-presetting
	CREATE_CONFIGURATION: 'domophone:createConfiguration', // device-setup/configurations
	LIST_CONFIGURATIONS: 'domophone:listConfigurations', // device-setup/configurations
	GET_CONFIGURATION: 'domophone:getConfiguration', // device-setup/configurations/{configurationId}
	UPDATE_CONFIGURATION: 'domophone:updateConfiguration', // device-setup/configurations/{configurationId}
	DELETE_CONFIGURATION: 'domophone:deleteConfiguration', // device-setup/configurations/{configurationId}
	GET_CAMERA_MODELS: 'domophone:getCameraModels', // device-setup/cameras/models
	GET_CAMERA_INSTRUCTIONS: 'domophone:getCameraInstructions', // device-setup/cameras/instructions
	GET_CAMERA_DETAILS: 'domophone:getCameraDetails', // device-setup/cameras/{cameraId}
	CONFIGURE_CAMERA: 'domophone:configureCamera', // device-setup/cameras/{cameraId}/configure
	CREATE_RESIDENTIAL_COMPLEX: 'domophone:createResidentialComplex', // residential-complexes
	GET_RESIDENTIAL_COMPLEXES: 'domophone:getResidentialComplexes', // residential-complexes
	GET_RESIDENTIAL_COMPLEX_BY_ID: 'domophone:getResidentialComplexById', // residential-complexes/{id}
	UPDATE_RESIDENTIAL_COMPLEX_BY_ID: 'domophone:updateResidentialComplexById', // residential-complexes/{id}
	DELETE_RESIDENTIAL_COMPLEX_BY_ID: 'domophone:deleteResidentialComplexById', // residential-complexes/{id}
	CREATE_COMPLEX_BUILDING: 'domophone:createComplexBuilding', // residential-complexes/{id}/buildings
	GET_COMPLEX_BUILDINGS: 'domophone:getComplexBuildings', // residential-complexes/{id}/buildings
	GET_COMPLEX_BUILDING_BY_ID: 'domophone:getComplexBuildingById', // residential-complexes/{id}/buildings/{buildingId}
	UPDATE_COMPLEX_BUILDING_BY_ID: 'domophone:updateComplexBuildingById', // residential-complexes/{id}/buildings/{buildingId}
	DELETE_COMPLEX_BUILDING_BY_ID: 'domophone:deleteComplexBuildingById', // residential-complexes/{id}/buildings/{buildingId}
	GET_ACCESS_MATRIX: 'domophone:getAccessMatrix', // residential-complexes/{id}/matrix
	UPDATE_ACCESS_MATRIX: 'domophone:updateAccessMatrix', // residential-complexes/{id}/matrix
	TEST_OPEN_RESIDENTIAL_COMPLEX: 'domophone:testOpenResidentialComplex', // residential-complexes/{id}/test-open
	CREATE_READER: 'domophone:createReader', // residential-complexes/readers
	GET_READERS: 'domophone:getReaders', // residential-complexes/{id}/readers
	GET_READER_BY_ID: 'domophone:getReaderById', // residential-complexes/{id}/readers/{readerId}
	GET_AVAILABLE_READERS: 'domophone:getAvailableReaders', // residential-complexes/{id}/readers/available
	LINK_READER_TO_RESIDENTIAL_COMPLEX: 'domophone:linkReaderToResidentialComplex', // residential-complexes/{id}/readers/{readerId}/link
	UNLINK_READER_FROM_RESIDENTIAL_COMPLEX: 'domophone:unlinkReaderFromResidentialComplex', // residential-complexes/{id}/readers/{readerId}/link

	START_WORKFLOW: 'domophone:startWorkflow', // workflow/start
	VIEW_WORKFLOW: 'domophone:viewWorkflow', // workflow/view/{sessionId}
	GET_EVENT_CHAIN_BY_SESSION_ID: 'domophone:getEventChainBySessionId', // workflow/view/{sessionId}/event-chain
	GET_EVENT_CHAIN: 'domophone:getEventChain', // workflow/event-chain/{eventFid}

	CREATE_SIP_TEST_COMBINED: 'domophone:createSipTestCombined', // /intercom/{appId}/panel/{flat}/combinedtest
	CHANGE_INTERCOM_STATUS: 'domophone:changeIntercomStatus', // /api/v1/partner/intercom
	LEGACY_CREATE_TOKEN: 'domophone:legacyCreateToken', // /legacy/auth/token
	REFRESH_TOKEN: 'domophone:refreshToken', // /legacy/auth/token/refresh
	LOGOUT: 'domophone:logout', // /legacy/auth/logout

	GET_CAMERAS: 'domophone:getCameras', // cameras
	ADD_CAMERA: 'domophone:addCamera', // /cameras
	GET_CAMERA_BY_ID: 'domophone:getCameraById', // /cameras/{id}
	DELETE_CAMERA_BY_ID: 'domophone:deleteCameraById', // /cameras/{id}
	SWITCH_CAMERA: 'domophone:switchCamera', // /cameras/{id}/switch/{state}
	RESTART_CAMERA: 'domophone:restartCamera', // /cameras/{id}/restart
	CAMERA_SERVERS_HISTORY: 'domophone:cameraServersHistory', // /cameras/{id}/servers-history
	GET_CAMERA_ACCOUNTS: 'domophone:getCameraAccounts', // /cameras/{id}/accounts
	GET_CAMERA_COMPANIES: 'domophone:getCameraCompanies', // /cameras/{id}/companies
	GET_CAMERA_TAGS: 'domophone:getCameraTags', // /cameras/{id}/tags
	POST_CAMERA_SHARED: 'domophone:postCameraShared', // /cameras/{id}/share
	GET_ACCOUNTS_GROUP_BY_ADDRESS: 'domophone:getAccountsGroupByAddress', // /cameras/{id}/accounts/group-by-address
	UPDATE_CAMERA_CREDENTIALS: 'domophone:updateCameraCredentials', // /cameras/{id}/credentials
	UPDATE_CAMERA_REFERENCE: 'domophone:updateCameraReference', // /cameras/{id}/reference
	UPDATE_CAMERA_RETURN_SLDP: 'domophone:updateCameraReturnSldp', // /cameras/{id}/sldp-links
	UPDATE_CAMERA_ARCHIVE: 'domophone:updateCameraArchive', // /cameras/{id}/archive
	UPDATE_CAMERA_SOUND: 'domophone:updateCameraSound', // /cameras/{id}/sound
	UPDATE_CAMERA_MODEL: 'domophone:updateCameraModel', // /cameras/{id}/model

	GET_ACCOUNTS: 'domophone:getAccounts', // /accounts
	GET_ACCOUNT_BY_ID: 'domophone:getAccountById', // /accounts/{id}
	DELETE_ACCOUNT: 'domophone:deleteAccount', // /accounts/{id}
	UPDATE_ACCOUNT: 'domophone:updateAccount', // /accounts/{id}
	GET_ACCOUNT_ADDRESSES: 'domophone:getAccountAddresses', // /accounts/{id}/addresses
	POST_ACCOUNT_ADDRESS: 'domophone:postAccountAddress', // /accounts/{id}/addresses
	GET_ACCOUNT_CAMERAS: 'domophone:getAccountCameras', // /accounts/{id}/cameras
	GET_ACCOUNT_SHARED_CAMERAS: 'domophone:getAccountSharedCameras', // /accounts/{id}/cameras/shared
	DELETE_ACCOUNT_ADDRESS: 'domophone:deleteAccountAddress', // /accounts/addresses/{id}
	UPDATE_INTERCOM_PANEL_FLAT_SETTINGS: 'domophone:updateIntercomPanelFlatSettings', // /intercom/{appId}/panel/flats/{flat}/settings
	GET_INTERCOM_PREVIEW_IMAGE: 'domophone:getIntercomPreviewImage', // /intercom/preview/image
	GET_INTERCOM_MCU_INFO: 'domophone:getIntercomMcuInfo', // /intercom/{appId}/mcu/info
	GET_GATES_OPEN_EVENTS: 'domophone:getGatesOpenEvents', // /report/gates/open-events
	GREETINGS_ANALYTICS_READ: 'domophone_greetings:listGreetings',
	GREETINGS_MANAGE: 'domophone_greetings:publishAudio',
	GREETINGS_AUDIO_LIST: 'domophone_greetings:listAudio',
	GREETINGS_AUDIO_CONTENT: 'domophone_greetings:adminAudioContent',
	GREETINGS_AUDIO_DELETE: 'domophone_greetings:deleteAudio',
	GREETINGS_BIRTHDAY_AVAILABILITY: 'domophone_greetings:setBirthdayAvailability',
	GREETINGS_STANDARD_SOUND_GET: 'domophone_greetings:getStandardSound',
	GREETINGS_STANDARD_SOUND_SET: 'domophone_greetings:setStandardSound',
	GREETINGS_CAMPAIGNS_LIST: 'domophone_greetings:listCampaigns',
	GREETINGS_CAMPAIGNS_CREATE: 'domophone_greetings:createCampaign',
	GREETINGS_CAMPAIGNS_UPDATE: 'domophone_greetings:updateCampaign',
	GREETINGS_CAMPAIGNS_CANCEL: 'domophone_greetings:cancelCampaign',
	GREETINGS_CAMPAIGNS_PAUSE: 'domophone_greetings:pauseCampaign',
	GREETINGS_CAMPAIGNS_RESUME: 'domophone_greetings:resumeCampaign',
	GREETINGS_CAMPAIGNS_STOP: 'domophone_greetings:stopCampaign',
	GREETINGS_OPERATIONS_EVENTS: 'domophone_greetings:operationalEvents',
	GREETINGS_OPERATIONS_SUMMARY: 'domophone_greetings:operationsSummary',
	GREETINGS_OPERATIONS_COMPONENTS: 'domophone_greetings:componentStates',
	GREETINGS_ANALYTICS: 'domophone_greetings:analytics',
	GREETINGS_SOUND_EXCLUSIONS_LIST: 'domophone_greetings:listSoundExclusions',
	GREETINGS_SOUND_EXCLUSIONS_CREATE: 'domophone_greetings:createSoundExclusion',
	GREETINGS_SOUND_EXCLUSIONS_UPDATE: 'domophone_greetings:updateSoundExclusion',
	GREETINGS_SOUND_EXCLUSIONS_DELETE: 'domophone_greetings:deleteSoundExclusion',
	GREETINGS_PANEL_STANDARD_SOUNDS_LIST: 'domophone_greetings:panelStandardSounds',
	GREETINGS_PANEL_STANDARD_SOUNDS_SET: 'domophone_greetings:setPanelStandardSound',
	GREETINGS_PANEL_STANDARD_SOUNDS_CLEAR: 'domophone_greetings:clearPanelStandardSound',
	BRAIN_CHAT_ASK: 'brainchat:brainChatAsk' // /n8n-chat/webhook/api/chat
} as const

export const AUTH_PERMISSIONS = {
	VIEW_MY_PERMISSIONS: 'authz:viewMyPermissions', // path: null
	ASSIGN_ROLE: 'authz:assignRole', // path: null
	REVOKE_ROLE: 'authz:revokeRole', // path: null
	CREATE_ROLE: 'authz:createRole', // path: null
	GRANT_PERMISSION: 'authz:grantPermission', // path: null
	REVOKE_PERMISSION: 'authz:revokePermission', // path: null
	GRANT_DIRECT_PERMISSION: 'authz:grantDirectPermission', // path: null
	GRANT_TEMPORARY_PERMISSION: 'authz:grantTemporaryPermission', // path: null
	VIEW_USER_PERMISSIONS: 'authz:viewUserPermissions', // path: null
	VIEW_USER_ROLES: 'authz:viewUserRoles', // path: null
	CHECK_PERMISSION: 'authz:checkPermission', // path: null
	VIEW_ROLES: 'authz:viewRoles', // path: null
	VIEW_ROLE_PERMISSIONS: 'authz:viewRolePermissions', // path: null
	VIEW_AUDIT_LOG: 'authz:viewAuditLog', // path: null
	RELOAD_POLICIES: 'authz:reloadPolicies', // path: null
	GRANT_ABAC_PERMISSION: 'authz:grantAbacPermission', // path: null
	VIEW_ABAC_POLICIES: 'authz:viewAbacPolicies', // path: null
	TEST_ABAC_POLICY: 'authz:testAbacPolicy' // path: null
} as const

export type DomophonePermission = (typeof DOMOPHONE_PERMISSIONS)[keyof typeof DOMOPHONE_PERMISSIONS]
export type AuthPermission = (typeof AUTH_PERMISSIONS)[keyof typeof AUTH_PERMISSIONS]

export type Permission = DomophonePermission | AuthPermission

/** Любое право, открывающее хотя бы одну вкладку звуковых сценариев; внутри вкладок проверяются точные операции. */
export const GREETINGS_PAGE_PERMISSIONS: DomophonePermission[] = [
	DOMOPHONE_PERMISSIONS.GREETINGS_ANALYTICS_READ,
	DOMOPHONE_PERMISSIONS.GREETINGS_MANAGE,
	DOMOPHONE_PERMISSIONS.GREETINGS_AUDIO_LIST,
	DOMOPHONE_PERMISSIONS.GREETINGS_STANDARD_SOUND_GET,
	DOMOPHONE_PERMISSIONS.GREETINGS_CAMPAIGNS_LIST,
	DOMOPHONE_PERMISSIONS.GREETINGS_OPERATIONS_EVENTS,
	DOMOPHONE_PERMISSIONS.GREETINGS_OPERATIONS_SUMMARY,
	DOMOPHONE_PERMISSIONS.GREETINGS_OPERATIONS_COMPONENTS,
	DOMOPHONE_PERMISSIONS.GREETINGS_ANALYTICS,
	DOMOPHONE_PERMISSIONS.GREETINGS_SOUND_EXCLUSIONS_LIST,
	DOMOPHONE_PERMISSIONS.GREETINGS_PANEL_STANDARD_SOUNDS_LIST
]

/** Все права домена authz (для проверок «есть ли доступ к админке авторизации»). */
export const AUTH_PERMISSIONS_LIST = Object.values(AUTH_PERMISSIONS) as AuthPermission[]
